import React, { useEffect, useState } from "react";
import Modal from "../../Modal";
import { useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { editTopic, getTopic } from "../../../features/slices/topicSlice";
import { toastService } from "../../../utils/toastify";

const EditTopic = ({ setShowTopic, id, topicData }) => {
  const [topicName, setTopicName] = useState("");
  const [errors, setErrors] = useState({});
  const { state } = useLocation();
  const dispatch = useDispatch();
  const handleClose = () => {
    setShowTopic((prev) => ({ ...prev, edit: false }));
  };
  useEffect(() => {
    setTopicName(topicData?.topicName);
  }, []);
  const validateForm = () => {
    let formErrors = {};
    let isValid = true;

    if (!topicName?.trim()) {
      formErrors.topicName = "topic name is required.";
      isValid = false;
    }

    setErrors(formErrors);
    return isValid;
  };
  const hanldeEditTopic = async () => {
    const data = {
      id: topicData?._id,
      topicName,
      categoryId: state,
    };
    if (validateForm()) {
      const res = await dispatch(editTopic(data));
      if (res?.payload?.code == 200) {
        toastService.success("Topic updated successfully");
        dispatch(getTopic({ page: 1, categoryId: state }));
        setShowTopic((prev) => ({ ...prev, edit: false }));
        handleClose();
      } else {
        toastService.error(res?.payload?.message);
      }
    }
  };
  return (
    <Modal>
      <div className="modal-body">
        <div className="Category">
          <a className="CloseModal" onClick={handleClose}>
            ×
          </a>
          <h3>Edit Topic</h3>
          <div className="form-group">
            <label>Topic Name</label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter Topic name"
              value={topicName}
              onChange={(e) => {
                setErrors("");
                setTopicName(e.target.value);
              }}
            />
            {errors.topicName && (
              <p className="d-flex justify-content-start text-danger mt-2 ">
                {errors.topicName}
              </p>
            )}
          </div>
          <button className="Button" onClick={hanldeEditTopic}>
            Update
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default EditTopic;
